<script>
import { generateConfirm, confirmTypeProps } from '@utils/feeline-confirm'
export default {
  props: {
    errors: {
      type: Object,
      require: false,
      default: () => {},
    },
    ...confirmTypeProps, // dialog confirm type
  },
  data() {
    return {
      openConfirm: false,
    }
  },
  computed: {
    confirmComputed() {
      return generateConfirm(this.type)
    },
  },
  watch: {
    errors() {
      if (this.errors) {
        this.$refs.observer.setErrors(this.errors)
      }
    },
  },
  methods: {
    showConfirm() {
      this.openConfirm = true
    },
    closeModalConfirm() {
      this.openConfirm = false
    },
    submit() {
      this.$emit('submit')
      this.closeModalConfirm()
    },
  },
}
</script>

<template>
  <validation-observer ref="observer" v-slot="{ handleSubmit }">
    <CForm @submit.stop.prevent="handleSubmit(showConfirm)">
      <CCard class="shadow-sm">
        <CCardHeader class="p-3">
          <slot name="header"></slot>
        </CCardHeader>
        <CCardBody>
          <slot></slot>
        </CCardBody>
        <CCardFooter align="right">
          <slot name="action">
            <CButton color="primary" type="submit">
              {{ confirmComputed.btn }}
            </CButton>
            <CButton
              type="button"
              color="dark"
              variant="outline"
              class="ml-2"
              @click="$emit('cancel')"
            >
              {{ $t('common.cancel') }}
            </CButton>
          </slot>
        </CCardFooter>
      </CCard>
    </CForm>
    <BaseModalConfirm
      :type="type"
      :show.sync="openConfirm"
      @closeModal="closeModalConfirm"
      @submit="submit"
    />
  </validation-observer>
</template>

<style lang="scss" scoped>
::v-deep .card-footer {
  border-top: none !important;
}
::v-deep .card-header {
  background-color: #f9f4ec !important;
}
</style>
